import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@fluentui/react-components";
import { Search24Regular } from "@fluentui/react-icons";
import { useSageAccess } from "../../products/access";
import { ATHENA_HOME } from "../../products/RequireProduct";
import { useAthenaSearchFlag } from "./features";
import styles from "./AthenaSearchButton.module.css";

interface Props {
  disabled?: boolean;
}

/**
 * AthenaSearchButton — header entry point to the Athena search product,
 * shown only when the access lookup positively grants athena AND the
 * per-caller athena_search feature flag is on (fail closed: a pending or
 * failed lookup renders nothing). A router <Link>: Athena lives inside this
 * app now, so the switch is an in-app navigation sharing the same Okta
 * session and token — no page reload.
 */
export const AthenaSearchButton: React.FC<Props> = ({ disabled = false }) => {
  const { status, hasAthena } = useSageAccess();
  const searchFlag = useAthenaSearchFlag();

  if (status !== "ready" || !hasAthena || searchFlag !== "on") {
    return null;
  }

  return (
    <div className={styles.button}>
      <Link to={ATHENA_HOME} className={styles.link} aria-disabled={disabled}>
        {/* Icon-only: the Bonds header row is capped at the chat column's
            847px; the Athena pair (search + chat) are glyphs whose label
            survives as aria-label + title. */}
        <Button disabled={disabled} className={styles.container} aria-label="Athena Search" title="Athena Search">
          <div className={styles.searchIcon}>
            <Search24Regular color="#002664" />
          </div>
        </Button>
      </Link>
    </div>
  );
};
